import { render, staticRenderFns } from "./VisorPedidosFiltros.vue?vue&type=template&id=1548b733&scoped=true"
import script from "./VisorPedidosFiltros.vue?vue&type=script&lang=js"
export * from "./VisorPedidosFiltros.vue?vue&type=script&lang=js"
import style0 from "./VisorPedidosFiltros.vue?vue&type=style&index=0&id=1548b733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1548b733",
  null
  
)

export default component.exports